import React from "react";
import { Tag } from "common/elements";
import StatusEnum from "./status";

export function Status({ type, title }) {
  const types = {
    normal: {
      background: "rgb(181 181 181 / 30%)",
    },
    success: {
      background: "rgb(135 208 104 / 30%)",
    },
    info: {
      background: "rgb(1 112 254 / 30%)",
    },
    warning: {
      background: "rgb(240 173 78 / 30%)",
    },
    danger: {
      background: "rgb(231 114 113 / 30%)",
    },
  };
  return (
    <Tag
      className="status-background"
      style={{
        color: "#87D068",
        ...types[type],
      }}
    >
      {title}
    </Tag>
  );
}

export function Approved() {
  return (
    <Tag
      className="status-background"
      style={{
        background: "rgb(135 208 104 / 30%)",
        color: "#87D068" 
      }}
    >
      {StatusEnum.APPROVED}
    </Tag>
  );
}

export function Normal() {
  return (
    <Tag
      className="status-background"
      style={{
        background: "rgb(135 208 104 / 30%)",
        color: "#87D068"
      }}
    >
      {StatusEnum.NORMAL}
    </Tag>
  );
}

export function Processed() {
  return (
    <Tag
      className="status-background"
      style={{
        background: "rgb(135 208 104 / 30%)",
        color: "#87D068"
      }}
    >
      {StatusEnum.PROCESSED}
    </Tag>
  );
}

export function Submitted() {
  return (
    <Tag
      className="status-background"
      style={{
        background: "#FFFF00",
        color: "black"
      }}
    >
      Submitted
    </Tag>
  );
}

export function Cancelled() {
  return (
    <Tag
      className="status-background"
      style={{
        backgroundColor: "rgb(181 181 181 / 30%)",
        color: "#B5B5B5"
      }}
    >
      {StatusEnum.CANCELLED}
    </Tag>
  );
}

export function RequiredUpdate() {
  return (
    <Tag
      className="status-background"
      style={{
        backgroundColor: "rgb(231 114 113 / 30%)",
        color: "#E77271"
      }}
    >
      Required Update
    </Tag>
  );
}

export function Rejected() {
  return (
    <Tag
      className="status-background"
      style={{
        backgroundColor: "rgb(231 114 113 / 30%)",
        color: "#E77271"
      }}
    >
      {StatusEnum.REJECTED}
    </Tag>
  );
}

export function Request() {
  return (
    <Tag
      className="status-background"
      style={{ background: "rgb(240 173 78 / 30%)", color: "#F0AD4E" }}
    >
      {StatusEnum.REQUEST}
    </Tag>
  );
}

export function Pending() {
  return (
    <Tag
      className="status-background"
      style={{ background: "rgb(240 173 78 / 30%)", color: "#F0AD4E" }}
    >
      {StatusEnum.PENDING}
    </Tag>
  );
}

export function ReqestCancel() {
  return (
    <Tag
      className="status-background"
      style={{ background: "rgb(240 173 78 / 30%)", color: "#F0AD4E" }}
    >
      {StatusEnum.REQUEST_CANCEL}
    </Tag>
  );
}

export function Reviewed() {
  return (
    <Tag
      className="status-background"
      style={{ background: "rgb(1 112 254 / 30%)", color: "#0170FE" }}
    >
      {StatusEnum.REVIEWED}
    </Tag>
  );
}

export function Verified() {
  return (
    <Tag
      className="task-status-background"
      style={{ background: "rgb(135 208 104 / 30%)", color: "#87D068" }}
    >
      {StatusEnum.VERIFIED}
    </Tag>
  );
}

export function Completed() {
  return (
    <Tag
      className="task-status-background"
      style={{ background: "rgb(135 208 104 / 30%)", color: "#87D068" }}
    >
      {StatusEnum.COMPLETED}
    </Tag>
  );
}

export function Progress() {
  return (
    <Tag
      className="task-status-background"
      style={{ background: "rgb(1 112 254 / 30%)", color: "#0170FE" }}
    >
      {StatusEnum.PROGRESS}
    </Tag>
  );
}

export function PendingTask() {
  return (
    <Tag
      className="task-status-background"
      style={{ background: "rgb(240 173 78 / 30%)", color: "#F0AD4E" }}
    >
      {StatusEnum.PENDING}
    </Tag>
  );
}
